import { FILE_TYPES } from '../../constants/fileTypes';

export const htmlFilesSelector = (state) =>
  state.files.data.filter(({ contentType }) => contentType === FILE_TYPES.HTML);
export const htmlFilesLoadingStatusSelector = (state) => state.files.status;
